import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Avatar(theme: Theme, containerId: string) {
  return {
    MuiAvatar: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        colorDefault: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.grey[400],
        },
      },
    },
    MuiAvatarGroup: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        avatar: {
          fontSize: 16,
          fontWeight: theme.typography.fontWeightMedium,
          '&:first-of-type': {
            fontSize: 14,
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.lighter,
          },
        },
      },
    },
  };
}
